import React from 'react';
import { Outlet, NavLink } from "react-router-dom"
import logo from './static/magicbox.png';
import QuickAdd from './components/QuickAdd';
import notificationStore from './stores/notification';
import Transaction from '@/../components/Transaction';

export default () => {

  const [notifications] = notificationStore((state) => [
    state.collection
  ])

  return (
    <>
      <div className="bg-white p-4 rounded-xl shadow-md mb-2">
        <div className="flex justify-between items-center">
          <div className="flex justify-start items-center gap-6">
            <img src={logo} alt="Magicbox" className="w-16 h-auto" />
            <h1 className="text-2xl font-bold">Magicbox</h1>
            <nav>
              <NavLink to="/" className={({isActive}) => `p-2 rounded ${isActive ? 'bg-sky-800 text-white' : ''}`}>Products</NavLink>
              <NavLink to="/transactions" className={({isActive}) => `p-2 rounded ${isActive ? 'bg-sky-800 text-white' : ''}`}>Transactions</NavLink>
              <NavLink to="/purchase-orders" className={({isActive}) => `p-2 rounded ${isActive ? 'bg-sky-800 text-white' : ''}`}>Purchase Orders</NavLink>
              <NavLink to="/reports" className={({isActive}) => `p-2 rounded ${isActive ? 'bg-sky-800 text-white' : ''}`}>Reports</NavLink>
              <NavLink to="/vendors" className={({isActive}) => `p-2 rounded ${isActive ? 'bg-sky-800 text-white' : ''}`}>Vendors</NavLink>
              <NavLink to="/loan-program" className={({isActive}) => `p-2 rounded ${isActive ? 'bg-sky-800 text-white' : ''}`}>Loan Program</NavLink>
              <NavLink to="/ops" className={({isActive}) => `p-2 rounded ${isActive ? 'bg-sky-800 text-white' : ''}`}>OPS</NavLink>
            </nav>
          </div>
          <QuickAdd />
        </div>
      </div>
      <div className="bg-white p-4 rounded-xl shadow-md">
        <Outlet />
      </div>
      <Transaction />
      <div className='fixed top-4 right-4 flex flex-col items-end gap-2'>
        {notifications && notifications.map((notification => 
          <div key={notification.id} className={`p-2 rounded ${(notification.type == 'error') ? 'bg-red-500' : 'bg-green-500'} text-white max-w-lg w-auto`}>
            {notification.message}
          </div>
        ))}
      </div>
    </>
  );
}
